import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="scent" routeLang="en" />;

export const Route = createFileRoute("/en/scent-for-your-store")({
  head: () => publicToolHead("scent", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
